import React from "react";
import { NavigateFunction } from "react-router-dom";
import OrdersIcon from "../../../../../images/common/cart-blue.svg";
import CartIcon from "../../../../../images/common/cart-blue.svg";
import { CountryWithStateModel, OrderRelatedGridModel, SystemColorsModel } from "../models";
import {
  ActiveInactiveButton,
  ITableHeaders,
  TableWithHeaderButtons,
  UtilityMethods,
  withRouter,
} from "@mindmemobile/mm-shared-global";
import PlaceholderSmallerGrid from "./PlaceholderSmallerGrid";
import TableGrid from "./TableGrid";
import { GridNames } from "../enums";
import { AccountSettingsStore } from "../store";

type IProps = {
  navigate: NavigateFunction;
  orders: OrderRelatedGridModel[];
  countriesWithState: CountryWithStateModel[];  
};
const RelatedOrdersGrid: React.FC<IProps> = ({ orders ,countriesWithState}) => {
  const headers = () => {
    const columns: ITableHeaders<OrderRelatedGridModel>[] = [
      {
        dataKey: "status",
        title: "Status",
        onCellRender: (data: OrderRelatedGridModel) => {
          let colors = SystemColorsModel.lightGreyColors();

          switch (data.status) {
            case "Draft":
              colors = SystemColorsModel.lightGreyColors();
              break;
            case "Sold":
              colors = SystemColorsModel.ligthGreenColors();
              break;
          }
          return (
            <ActiveInactiveButton color={colors.color} bgColor={colors.bgColor}>
              {data.status}
            </ActiveInactiveButton>
          );
        },
      },
      {
        dataKey: "createdDate",
        title: "Date",
        onCellRender: (data: OrderRelatedGridModel) => {
          return UtilityMethods.formatDateInString(data.createdDate);
        },
      },

      {
        dataKey: "description",
        title: "Description",
        onCellRender: (data: OrderRelatedGridModel) => {
          return data.description;
        },
      },
      {
        dataKey: "totalItems",
        title: "Items",
        onCellRender: (data: OrderRelatedGridModel) => {
          return UtilityMethods.numberWithCommas(data.totalItems);
        },
      },
      {
        dataKey: "amount",
        title: "Amount",
        onCellRender: (data: OrderRelatedGridModel) => {
          return "$" + AccountSettingsStore.formatAmount(data.amount);
        },
      },
    ];
    return columns;
  };

  if (orders.length == 0)
    return (
      <PlaceholderSmallerGrid
        title="No Orders"
        icon={CartIcon}
        buttonCaption="New"
      />
    );

  return (
    <TableGrid
      wrapperClassName="table-with-header-btns"
      tableHeader={
        <TableWithHeaderButtons
          isShowHeaderButton={true}
          totalItems={orders.length}
          icon={OrdersIcon}
          title="Orders"
        />
      }
      cellSpacing={20}
      headers={headers()}
      data={orders}
      totalItemCount={orders.length}
      name={GridNames.Order}
      countriesWithState={countriesWithState}
    />
  );
};

export default withRouter(RelatedOrdersGrid);
